<template>
  <div class="col-md-12">
    <div v-if="currentMember" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Edit Member Details</h4>
      <form name="form" @submit.prevent="updateMember">
        <div v-if="!successful">
     
          <div class="form-group">
            <label for="networkMemberId">Network Member ID:</label>
            <input v-model="currentMember.networkMemberId" v-validate="'required|min:9|max:12'" type="text" class="form-control" id="networkMemberId" name="networkMemberId" readonly="readonly"/>
            <div v-if="submitted && errors.has('networkMemberId')" class="alert-danger">{{errors.first('networkMemberId')}}</div>
          </div>
          <div class="form-group">
            <label for="surname">Surname:</label>
            <input v-model="currentMember.surname" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="surname" name="surname"/>
            <div v-if="submitted && errors.has('surname')" class="alert-danger" >{{errors.first('surname')}}</div>
          </div>
          <div class="form-group">
            <label for="firstName">First Name:</label>
            <input v-model="currentMember.firstName" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="firstName" name="firstName"/>
            <div v-if="submitted && errors.has('firstName')" class="alert-danger" >{{errors.first('firstName')}}</div>
          </div>
          <div class="form-group">
            <label for="middleName">Middle Name:</label>
            <input v-model="currentMember.middleName" v-validate="'max:75'" type="text" class="form-control" id="middleName" name="middleName"/>
            <div v-if="submitted && errors.has('middleName')" class="alert-danger" >{{errors.first('middleName')}}</div>
          </div>
          <div class="form-group">
            <label for="gender">Gender:</label>
            <select v-model="currentMember.gender" v-validate="'required|min:4|max:6'" class="form-control" id="gender" name="gender">
              <option>{{ currentMember.gender }}</option>
              <option>Female</option>
              <option>Male</option>
            </select>
            <div v-if="submitted && errors.has('gender')" class="alert-danger" >{{errors.first('gender')}}</div>
          </div>
          <div class="form-group">
            <label for="address">Address:</label>
            <input v-model="currentMember.address" v-validate="'required|min:6|max:95'" type="text" class="form-control" id="address" name="address"/>
            <div v-if="submitted && errors.has('address')" class="alert-danger" >{{errors.first('address')}}</div>
          </div>
          <!--<div class="form-group">
            <label for="countries">Country: </label>
            <select v-model="currentMember.country" @change="onChangeCountry($event)" v-validate="'required|min:3|max:75'" class="form-control" id="countries" name="countries">
              <option v-for="country in countries" v-bind:value="country.id" :key="country.id">{{ country.name }}</option>
            </select>
            <div v-if="submitted && errors.has('countries')" class="alert-danger">{{errors.first('countries')}}</div>
          </div>
          <div class="form-group">
            <label for="states">State: </label>
            <select v-model="currentMember.state" @change="onChangeState($event)" v-validate="'required|min:3|max:75'" class="form-control" id="states" name="states">
              <option v-for="state in states" v-bind:value="state.id" :key="state.id">{{ state.name }}</option>
            </select>
            <div v-if="submitted && errors.has('states')" class="alert-danger">{{errors.first('states')}}</div>
          </div>-->
          <div class="form-group">
            <label for="country">Country:</label>
            <input v-model="currentMember.country" v-validate="'required|min:2|max:75'" type="text" class="form-control" id="country" name="country" readonly="readonly"/>
            <div v-if="submitted && errors.has('country')" class="alert-danger" >{{errors.first('country')}}</div>
          </div>
          <div class="form-group">
            <label for="state">State:</label>
            <input v-model="currentMember.state" v-validate="'required|max:75'" type="text" class="form-control" id="state" name="state" readonly="readonly"/>
            <div v-if="submitted && errors.has('state')" class="alert-danger" >{{errors.first('state')}}</div>
          </div>
          <div class="form-group">
            <label for="phoneNumber">Phone Number:</label>
            <input v-model="currentMember.phoneNumber" v-validate="'required|min:9|max:16'" type="number" class="form-control" id="phoneNumber" name="phoneNumber"/>
            <div v-if="submitted && errors.has('phoneNumber')" class="alert-danger" >{{errors.first('phoneNumber')}}</div>
          </div>
          <div class="form-group">
            <label for="email">Email:</label>
            <input v-model="currentMember.email" v-validate="'required|min:11|max:75'" type="email" class="form-control" id="name" name="email"/>
            <div v-if="submitted && errors.has('email')" class="alert-danger" >{{errors.first('email')}}</div>
          </div>
          <div class="form-group">
            <label for="members">Sponsor/Upline: </label>
            <input v-model="currentMember.sponsor" v-validate="'required|min:9|max:12'" type="text" class="form-control" id="sponsor" name="sponsor" readonly="readonly"/>
            <div v-if="submitted && errors.has('sponsor')" class="alert-danger">{{errors.first('sponsor')}}</div>
          </div>
          <div class="form-group">
            <label for="joinedDate">Joined Date:</label>
            <input v-model="currentMember.joinedDate" v-validate="'required|min:10|max:10'" type="date" class="form-control" id="joinedDate" name="joinedDate"/>
            <div v-if="submitted && errors.has('joinedDate')" class="alert-danger" >{{errors.first('joinedDate')}}</div>
          </div>
          <div class="form-group">
            <label for="bank">Bank:</label>
            <select v-model="currentMember.bank" v-validate="'required|max:75'" class="form-control" id="bank" name="bank">
              <option>{{ currentMember.bank }}</option>
              <option>Access Bank</option>
              <option>Citibank</option>
              <option>Ecobank</option>
              <option>Fidelity Bank</option>
              <option>First Bank</option>
              <option>First City Monument Bank (FCMB)</option>
              <option>FSDH Merchant Bank</option>
              <option>Guarantee Trust Bank (GTB)</option>
              <option>Heritage Bank</option>
              <option>Keystone Bank</option>
              <option>Rand Merchant Bank</option>
              <option>Polaris Bank</option>
              <option>Stanbic IBTC Bank</option>
              <option>Standard Chartered Bank</option>
              <option>Sterling Bank</option>
              <option>Suntrust Bank</option>
              <option>Union Bank</option>
              <option>United Bank for Africa (UBA)</option>
              <option>Unity Bank</option>
              <option>Wema Bank</option>
              <option>Zenith Bank</option>
            </select>
            <div v-if="submitted && errors.has('bank')" class="alert-danger" >{{errors.first('bank')}}</div>
          </div>
          <div class="form-group">
            <label for="accountNumber">Account Number:</label>
            <input v-model="currentMember.accountNumber" v-validate="'required|min:10|max:10'" type="number" class="form-control" id="accountNumber" name="accountNumber"/>
            <div v-if="submitted && errors.has('accountNumber')" class="alert-danger" >{{errors.first('accountNumber')}}</div>
          </div>
          <div class="form-group">
            <label for="accountName">Account Name:</label>
            <input v-model="currentMember.accountName" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="accountName" name="accountName"/>
            <div v-if="submitted && errors.has('accountName')" class="alert-danger" >{{errors.first('accountName')}}</div>
          </div>
          
          <div class="form-group">
            <button class="badge badge-danger mr-2" @click="deleteMember"><font-awesome-icon icon="trash-alt" /> Delete</button>
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Update</button>
            <button class="badge badge-primary" @click="membersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="membersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
      </div>
    </div>
    <div v-else>
      <br />
      <p>Please click on a Member...</p>
    </div>
  </div>
</template>

<script>
import MemberService from "../services/member.service";
import CountryService from "../services/country.service";
import StateService from "../services/state.service";

export default {
  name: 'member',
  data() {
    return {
      currentMember: null,
      submitted: false,
      successful: false,
      message: '',
      countries: [],
      states: [],
      members: [],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getMember(id) {
      MemberService.get(id)
        .then(response => {
          this.currentMember = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    retrieveCountries() {
      CountryService.getAll()
        .then(response => {
          this.countries = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeCountry: function(e) {
      this.currentMember.country = e.target.value;
      this.retrieveStatesByCountry();
    },

    retrieveStatesByCountry() {
      StateService.getStatesByCountry(this.member.country)
        .then(response => {
          this.states = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    retrieveStates() {
      StateService.getAll()
        .then(response => {
          this.states = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeState: function(e) {
      this.currentMember.state = e.target.value;
    },

    retrieveMembers() {
      MemberService.getAll()
        .then(response => {
          this.members = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

     onChangeMember: function(e) {
      this.currentMember.sponsor = e.target.value;
      this.currentMember.upline = this.currentMember.sponsor;
    },
    
    updateMember() {
      this.message = '';
      this.submitted = true;
      //this.currentMember.countryId = this.currentcountryId;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          MemberService.update(this.currentMember.id, this.currentMember).then(
            response => {
              console.log(response.data);
              this.message = 'The member was updated successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },

    deleteMember() {
      MemberService.delete(this.currentMember.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "members" });
        })
        .catch(e => {
          console.log(e);
        });
    },

    membersList() {
      this.$router.push('/members');
    }
  },
  mounted() {
    this.message = '';
    this.getMember(this.$route.params.id);
    this.retrieveCountries();
    this.retrieveStates();
    this.retrieveMembers();
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>